(function () {
    'use strict';

    $('.org-search-header form').on('submit', function (e) {
        return $(this).find('input[type="search"]').val().trim() !== '';
    });
})();
